import React from 'react'
import clsx from 'clsx'

import { useLayoutStyles } from '../common'

export type MainLayoutSidebarNewProps = {
  withSticky?: boolean
  className?: string
  style?: React.CSSProperties
  size?: 'large' | 'small'
  hideMobile?: boolean
}

export const MainLayoutSidebarNew: React.FC<MainLayoutSidebarNewProps> = (
  props
) => {
  const classes = useLayoutStyles()

  return (
    <div
      className={clsx(
        classes.leftColumnRoot,
        {
          [classes.sticky]: props.withSticky,
          [classes.small]: props.size === 'small',
          [classes.large]: props.size === 'large',
          [classes.hidden]: props.hideMobile
        },
        props.className
      )}
      style={props.style}
    >
      {props.children}
    </div>
  )
}

MainLayoutSidebarNew.defaultProps = {
  size: 'small'
}
